import React, { Component } from 'react';

import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

import GrupoReportes from './GrupoReportes';
import PantallaReporte from './PantallaReporte';

import { LogsProxy } from 'com-gyf-webcore-servicehub';
class InvocadorReportes extends Component {
	constructor(props){
		super(props);
		this.state = { pantalla: 'list', reporteSeleccionado: null };                
	}

    componentDidMount() {
        this.props.getScreenData( this.props.currentScope, this.props.login, this.props.adUserGroup );
    }

    componentWillUnmount() {
        this.props.resetStateReports();
    }

    setReporteSeleccionado(reporte) {
        if (reporte.path.indexOf("ReportAuditLog") !== -1) {
            LogsProxy.SaveOperationLog("SEGURIDAD,REPORTE,AUDITORIA", "Ingreso al reporte 'Log de Auditoria'", null, null, null, null, null, "SEGURIDAD");

        } else if (reporte.path.indexOf("LogSeguridad") !== -1)
        {
            LogsProxy.SaveOperationLog("SEGURIDAD,REPORTE,AUDITORIA", "Ingreso al reporte 'Log de Seguridad'", null, null, null, null, null, "SEGURIDAD");
        }
		this.setState({reporteSeleccionado: reporte, pantalla: 'reporte'});
	}
	
	volver() {
		this.setState({reporteSeleccionado: null, pantalla: 'list'});
	}
	
	render() {
        const { functions, nombre, gruposReportes } = this.props;

        if (functions && functions.length == 0)
            return null;

        if (functions.Consulta == true) {
            if (this.state.pantalla === 'list') {
                return (
                    <div>
                        <ListReportes
                            nombre={nombre}
                            gruposReportes={gruposReportes}
                            setReporteSeleccionado={(reporte) => this.setReporteSeleccionado(reporte)}
                            producto={this.props.currentScope.ProductCode} />
                    </div>
                );
            }

            if (this.state.pantalla === 'reporte') {
                return (
                    <div>
                        <PantallaReporte reporte={this.state.reporteSeleccionado} volver={() => this.volver()} />
                    </div>
                );
            }
        }
        else {
            let values = {
                message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                linkMessage: "Volver a mi pagina de inicio"
            };

            return <GenericErrorScreen data={values} />;
        }
	}
}

const ListReportes = ({ nombre, gruposReportes, setReporteSeleccionado, producto}) => {	
	if (gruposReportes.length === 0) {
		return (
			<div>
				<h1>Reportes</h1>
				<div>
					<p>Sin reportes disponibles</p>
				</div>

			</div>
		);
	}

	return (
		<div>
			<h1>Reportes</h1>
			<div>
			    {gruposReportes.map(g => <GrupoReportes grupo={g} setReporteSeleccionado={setReporteSeleccionado} producto={producto} />)}
			</div>
		
		</div>
	);	
}

export default InvocadorReportes;


// WEBPACK FOOTER //
// ./Portico/App/Screens/InvocadorReportes/components/InvocadorReportes.jsx